import React from "react";
import { toast } from "react-toastify";
import classnames from "classnames";

import FilterComponent from "../../../../../asset/simple_asset/helper/component/FilterComponent.js";
import iconMaping from "../../../../../utils/IconMaping.js";
import DetailRow from "./DetailRow.js";
import ModalQRScanner from "../../../../../qrreader/helper/component/Modal/ModalQRScanner.js";
// Component
import Pagination from "../../../../../component/Pagination.js";
import {
  TableRowEmpty,
  TableRowLoading
} from "../../../../../component/ComponentHelper.js";
/*import CheckPermission from '../../../../../component/CheckPermission.js'

// Config
import PermissionProperties from '../../../../../config/permission.js'*/
import Request from "../../../../../config/Request.js";
//Utils
import handlingError from "../../../../../utils/handlingError.js";
import windowStop from "../../../../../utils/windowStop.js";

// import Modal from './Modal.js';

const { ReactNativeWebView } = window;

export default class DetailList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      rawData: [],
      modalQRScanner: false,
      isModal: false,
      modalMode: null,
      data: { site: "" },
      activeToggle: { activeIcon: null, activeField: "Name" },
      is_process: false,
      // ***Pagination
      table_loading: false,
      current: 0,
      count: 0,
      limit: 0
    };

    this.loading = true;
    this.tab = ["name", "serial_number"];

    this.params_filter = "";
    this.params_order = "-CheckedTime";
    this.params_page = 1;
    this.site = JSON.parse(atob(props.match.params.SiteName));

    this.onRead = this.onRead.bind(this);
    this.onReadSuccess = this.onReadSuccess.bind(this);
    this.onReadFailed = this.onReadFailed.bind(this);

    this.onRegister = this.onRegister.bind(this);
    this.onRegisterSuccess = this.onRegisterSuccess.bind(this);
    this.onRegisterFailed = this.onRegisterFailed.bind(this);

    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);

    this.closeModalQRScanner = this.closeModalQRScanner.bind(this);
    this.openModalQRScanner = this.openModalQRScanner.bind(this);

    this.handlePageClick = this.handlePageClick.bind(this);
    this.handleMobile = this.handleMobile.bind(this);
  }

  openModal(mode) {
    this.setState({
      modalMode: mode,
      isModal: true
    });
  }

  closeModal() {
    this.setState({ isModal: false });
  }

  openModalQRScanner() {
    if (ReactNativeWebView) {
      ReactNativeWebView.postMessage(
        JSON.stringify({
          type: "QRScan",
          data: this.props.match.params.StockAlias,
          site: this.site
        })
      );
    } else {
      this.setState({
        modalQRScanner: true
      });
    }
  }

  closeModalQRScanner() {
    this.setState({
      modalQRScanner: false
    });
    this.props.onReadAll();
  }

  generateRow(row) {
    return row.map((val, index) => {
      return (
        <DetailRow
          key={index}
          isModal={this.state.isModal}
          RowData={val}
          history={this.props.history}
          open={this.openModal}
          close={this.closeModal}
        />
      );
    });
  }

  updateRow(type, result) {
    let rawData = this.state.rawData;
    for (var i = 0; i < rawData.length; i++) {
      if (rawData[i].Alias === result.Alias) {
        rawData[i] = result;
        break;
      }
    }
    this.setState({ rawData });
  }

  onRead() {
    let data = Object.assign(
      {
        page: this.params_page,
        ordering: this.params_order,
        stocktake: this.props.match.params.StockAlias,
        state: this.props.cluster === "all" ? "" : this.props.cluster
      },
      this.params_filter
    );

    Request(
      "get",
      "read-job-stock-details",
      { Authorization: "Bearer " + this.props.UserReducer.token },
      data,
      [],
      this.onReadSuccess,
      this.onReadFailed
    );
  }

  onReadSuccess(response) {
    this.loading = false;
    this.setState({
      rawData: response.data.results,
      table_loading: false,
      current: response.data.current,
      count: response.data.count,
      limit: response.data.limit
    });
  }

  onReadFailed(error) {
    this.loading = false;
    this.setState({ is_process: false });
    handlingError(error.response.data);
  }

  // ==================== Register
  onRegister(data) {
    let payload = {
      _Site: data.site
    };

    Request(
      "post",
      "register-job-stock",
      { Authorization: "Bearer " + this.props.UserReducer.token },
      payload,
      [],
      this.onRegisterSuccess,
      this.onRegisterFailed
    );

    this.setState({ is_process: true });
  }

  onRegisterSuccess(response) {
    toast.success("Register contact success");
    this.onRead();
    this.closeModal();
    this.setState({ is_process: false });
  }

  onRegisterFailed(error) {
    this.setState({ is_process: false });
    handlingError(error.response.data);
  }

  dataWillFilter(filter) {
    this.params_filter = filter;
    this.params_page = 1;

    this.onRead();
  }

  dataWillOrder(order) {
    let parameter_order = order;
    this.setState({
      activeToggle: {
        activeField: order,
        activeIcon: iconMaping.AVICON_ASC
      }
    });

    if (this.params_order === parameter_order) {
      this.params_order = "-" + order;
      this.setState({
        activeToggle: {
          activeField: order,
          activeIcon: iconMaping.AVICON_DESC
        }
      });
    } else {
      this.params_order = parameter_order;
      this.setState({
        activeToggle: {
          activeField: order,
          activeIcon: iconMaping.AVICON_ASC
        }
      });
    }

    this.onRead();
  }

  componentDidMount() {
    this.onRead();
    this.props.onRef(this);
    if (ReactNativeWebView) {
      document.addEventListener("message", this.handleMobile);
      window.addEventListener("message", this.handleMobile);
    }
  }

  componentWillUnMount() {
    if (ReactNativeWebView) {
      document.removeEventListener("message", this.handleMobile);
      window.removeEventListener("message", this.handleMobile);
    }
    this.props.onRef(undefined);
    windowStop();
  }

  handleMobile({ data }) {
    if (data === "read") {
      this.onRead();
    }
  }

  handlePageClick = data => {
    windowStop();
    let selected = data.selected + 1;
    this.params_page = selected;

    this.setState({
      table_loading: true
    });

    this.onRead();
  };

  RenderRow() {
    if (this.loading) {
      return <TableRowLoading />;
    } else if (this.state.rawData.length > 0) {
      return this.generateRow(this.state.rawData);
    } else {
      return <TableRowEmpty />;
    }
  }

  renderTitle(cluster, count) {
    if (cluster === "available") {
      return (
        <div className="row">
          <div className="col-sm-5 book-a-tool-title">
            <h4 className="card-title mb-0">
              <button
                className="fa fa-arrow-left button-back btn-link no-underline"
                role="presentation"
                onClick={() => this.props.history.goBack()}
              />
              Available Job Stock Details
              <small className="mr-ml-8">for site</small>
              {this.site.Name}
            </h4>
            <div className="text-muted m-top-8">
              <div className="pull-left spaceRRR cursor-default">
                Total:&nbsp;{count}&nbsp;Assets
              </div>
            </div>
          </div>
          <div className="col-sm-7">
            <FilterComponent
              onSearch={e => {
                this.dataWillFilter(e);
              }}
              self={this}
              target={"available"}
              FBColumn={this.tab}
              version={2}
            />
          </div>
        </div>
      );
    } else if (cluster === "unconfirmed") {
      return (
        <div className="row">
          <div className="col-sm-5 book-a-tool-title">
            <h4 className="card-title mb-0">
              <button
                className="fa fa-arrow-left button-back btn-link no-underline"
                role="presentation"
                onClick={() => this.props.history.goBack()}
              ></button>
              Unconfirmed Job Stock Details
              <small className="mr-ml-8">for site</small>
              {this.site.Name}
            </h4>
            <div className="text-muted m-top-8">
              <div className="pull-left spaceRRR cursor-default">
                Total:&nbsp;{count}&nbsp;Assets
              </div>
            </div>
          </div>
          <div className="col-sm-7">
            <FilterComponent
              onSearch={e => {
                this.dataWillFilter(e);
              }}
              self={this}
              target={"unconfirmed"}
              FBColumn={this.tab}
              version={2}
            />
          </div>
        </div>
      );
    } else {
      return (
        <div className="row">
          <div className="col-sm-5 book-a-tool-title">
            <h4 className="card-title mb-0">
              <button
                className="fa fa-arrow-left button-back btn-link no-underline"
                role="presentation"
                onClick={() => this.props.history.goBack()}
              />
              All Job Stock Details<small className="mr-ml-8">for site</small>
              {this.site.Name}
            </h4>
            <div className="text-muted m-top-8">
              <div className="pull-left spaceRRR cursor-default">
                Total:&nbsp;{count}&nbsp;Assets
              </div>
            </div>
          </div>
          <div className="col-sm-7">
            <FilterComponent
              onSearch={e => {
                this.dataWillFilter(e);
              }}
              self={this}
              target={"all"}
              FBColumn={this.tab}
              version={2}
            />
          </div>
        </div>
      );
    }
  }

  render() {
    const { activeToggle, current, count, limit, table_loading } = this.state;

    return (
      <div>
        {this.renderTitle(this.props.cluster, count)}
        <div className="row">
          <div className="col-md-12 mt-4">
            <button
              className="btn btn-sm btn-primary"
              onClick={() => this.openModalQRScanner()}
            >
              <i className={iconMaping.AVICON_QR} /> Scan Asset's QR
            </button>
          </div>
        </div>
        <div className="table-wrapper">
          <table
            className={classnames(
              "table table-hover table-outline mb-0 m-top-15",
              { loading: table_loading }
            )}
          >
            <thead className="thead-default">
              <tr>
                <th
                  onClick={() => this.dataWillOrder("Asset__Name")}
                  className="pointer"
                >
                  Asset Name
                  {activeToggle.activeField === "Asset__Name" && (
                    <i className={activeToggle.activeIcon}></i>
                  )}
                </th>
                <th
                  onClick={() => this.dataWillOrder("CheckedTime")}
                  className="pointer"
                >
                  Checked Time
                  {activeToggle.activeField === "CheckedTime" && (
                    <i className={activeToggle.activeIcon}></i>
                  )}
                </th>
                <th className="text-center">Status</th>
              </tr>
            </thead>
            <tbody>{this.RenderRow()}</tbody>
          </table>
        </div>
        <div className="row m-top-15">
          <div className="col-md-12 text-center">
            <Pagination
              current={current}
              count={count}
              limit={limit}
              handle={this.handlePageClick}
              isLoading={this.state.table_loading}
            />
          </div>
        </div>

        {/*<Modal
          isModal     = {this.state.isModal}
          open        = {this.openModal}
          close       = {this.closeModal}
          mode        = {this.state.modalMode}
          register    = {this.onRegister}
          // update   = {this.onUpdate}
          data        = {this.state.data}
          is_process  = {this.state.is_process}
          UserReducer = {this.props.UserReducer}
        />*/}

        <ModalQRScanner
          onSuccess={() => undefined}
          isOpen={this.state.modalQRScanner}
          closeModal={this.closeModalQRScanner}
          openModalInsertTag={() => undefined}
          scanType="stock_take"
          data={{
            stockTake: this.props.match.params.StockAlias
          }}
          RunRedux={this.props.RunRedux}
          UserReducer={this.props.UserReducer}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App/job/job_stock_check/helper/component/detail/DetailList.js